import { render } from "./beforeCall.vue?vue&type=template&id=64e57c8e&scoped=true"
import script from "./beforeCall.vue?vue&type=script&lang=js"
export * from "./beforeCall.vue?vue&type=script&lang=js"

import "./beforeCall.vue?vue&type=style&index=0&id=64e57c8e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\owner\\Desktop\\Project\\webrtc\\tsunagaru\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e57c8e"]])

export default __exports__